// Landing page (signed-in default). For now a static welcome card pointing
// to the Drafts tab — when the drafts dashboard lands in B3 we'll either
// redirect / → /drafts or keep this as a deliberate landing screen with
// summary stats.

import { Link } from 'react-router-dom';
import { AdminShell } from '@/components/AdminShell';

export function HomePage() {
  return (
    <AdminShell>
      <h1 className="text-2xl font-semibold tracking-tight">Welcome</h1>
      <p className="mt-2 text-slate-600">
        This is the internal admin for tee. Use the nav above to review
        menu-import drafts, manage the catalog, or adjust settings.
      </p>

      <section className="mt-10 grid gap-4 sm:grid-cols-3">
        <LinkCard to="/drafts" label="Drafts" hint="Approve or reject pending menu imports." />
        <LinkCard to="/catalog" label="Catalog" hint="Curate unverified ingredients + aliases." />
        <LinkCard to="/settings" label="Settings" hint="Per-user preferences." />
      </section>
    </AdminShell>
  );
}

function LinkCard({ to, label, hint }: { to: string; label: string; hint: string }) {
  return (
    <Link
      to={to}
      className="card p-5 hover:border-slate-300 hover:shadow transition-shadow"
    >
      <p className="font-medium text-slate-900">{label}</p>
      <p className="mt-1 text-sm text-slate-500">{hint}</p>
    </Link>
  );
}
